export const ADMIN_ROLE = 'admin'
export const COLLEGE_ROLE = 'college'
export const TEACHER_ROLE = 'teacher'
export const ADMINISTRATOR_ROLE = 'administrator'
export const HOD_ROLE = 'hod'
